import * as React from 'react';

import moment from 'moment';

import {DistributionBar} from 'shells/card/distribution-bar/distribution-bar';
import {colors} from 'shells/colors/colors';
import {StackLegacy} from 'shells/layout/stack/stack-legacy';
import {ThumbnailButtonCard} from 'shells/thumbnail/thumbnail-button-card/thumbnail-button-card';
import {FormattedTimestamp} from 'shells/timestamp/formatted-timestamp';
import {Body} from 'shells/typography/body';
import {Title} from 'shells/typography/title';

import type {CampaignType} from 'nutshell-graphql-types';
import type {EditionFragment as Edition} from 'nutshell-graphql-types';

import {REMAINDER} from '../a-b-testing/edition-content/a-b-test-details';
import {getComparisonDetails} from '../a-b-testing/helpers';

import {PreviewData} from './preview-data';

import styles from './preview-body.module.css';

type Props = {
    edition: Edition;
    scheduledDate: moment.Moment | null | undefined;
    type: CampaignType;
};

export function PreviewBody(props: Props) {
    const comparisonEditionTemplate =
        props.edition.comparisonEdition && props.edition.comparisonEdition.emailTemplate;
    const {comparisonSubject, comparisonPreviewText, comparisonThumbnailUrl} = getComparisonDetails(
        props.edition,
        comparisonEditionTemplate
    );

    const sections = [
        {
            type: 'defined',
            color: colors.plum,
            percent: (props.edition.comparison && props.edition.comparison.sendPercentage / 2) || 0,
            label: 'A',
            labelColor: colors.white,
        },
        {
            type: 'defined',
            color: colors.sidebarPrimary,
            percent: (props.edition.comparison && props.edition.comparison.sendPercentage / 2) || 0,
            label: 'B',
            labelColor: colors.white,
        },
    ];

    return (
        <div className={styles['preview-container']}>
            <div
                style={{height: props.edition.isABTesting ? '' : '50%'}}
                className={styles['column-container']}
            >
                <div className={styles['thumbnail-container']}>
                    <ThumbnailButtonCard
                        title={
                            props.edition.emailTemplate ? props.edition.emailTemplate.subject : ''
                        }
                        secondaryInfo={
                            props.edition.emailTemplate && props.edition.emailTemplate.previewText
                        }
                        tertiaryInfo={props.edition.isABTesting ? 'Version A' : undefined}
                        thumbnail={
                            props.edition.emailTemplate && props.edition.emailTemplate.thumbnailUrl
                        }
                        thumbnailHeight={props.edition.isABTesting ? 129 : 201}
                        onClick={() => {}}
                        isDisabled={true}
                        backgroundColor={props.edition.backgroundColor}
                    />
                </div>
                {props.edition.isABTesting ? (
                    <div className={styles['thumbnail-container']}>
                        <ThumbnailButtonCard
                            title={comparisonSubject || ''}
                            secondaryInfo={comparisonPreviewText}
                            tertiaryInfo='Version B'
                            thumbnail={comparisonThumbnailUrl}
                            thumbnailHeight={129}
                            onClick={() => {}}
                            isDisabled={true}
                            backgroundColor={props.edition.backgroundColor}
                        />
                    </div>
                ) : undefined}
            </div>
            <div className={styles['column-container']}>
                <div className={styles['preview-container-right']}>
                    <StackLegacy spacing={16}>
                        {props.type === 'NEWSLETTER' ? (
                            <>
                                <div>
                                    <Title>Newsletter</Title>
                                </div>
                                <Body>{props.edition.campaign.name}</Body>
                                <div style={{marginTop: '16px'}}>
                                    <Title>Edition</Title>
                                </div>
                                <Body>{props.edition.name}</Body>
                            </>
                        ) : (
                            <>
                                <div>
                                    <Title>Broadcast</Title>
                                </div>
                                <Body>{props.edition.name}</Body>
                            </>
                        )}
                        {props.scheduledDate ? (
                            <>
                                <div>
                                    <Title>Sending on</Title>
                                </div>
                                <Body>
                                    <FormattedTimestamp
                                        datetime={props.scheduledDate.unix()}
                                        format={FormattedTimestamp.formats.longDateWithTime}
                                        addTimezoneAbbreviation={true}
                                    />
                                </Body>
                            </>
                        ) : undefined}
                        <PreviewData edition={props.edition} />
                    </StackLegacy>
                </div>
                {props.edition.isABTesting ? (
                    <div style={{alignSelf: 'stretch'}}>
                        {/* @ts-expect-error */}
                        <DistributionBar sections={sections} remainder={REMAINDER} />
                    </div>
                ) : undefined}
            </div>
        </div>
    );
}
